/* tslint:disable */
/* eslint-disable */
/**
 * TRWL API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { Size } from './size';

/**
 * 
 * @export
 * @interface ProductFilter
 */
export interface ProductFilter {
    /**
     * 
     * @type {number}
     * @memberof ProductFilter
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof ProductFilter
     */
    'size': number;
    /**
     * 
     * @type {string}
     * @memberof ProductFilter
     */
    'keyword'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFilter
     */
    'sortField'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFilter
     */
    'sortOrder'?: ProductFilterSortOrderEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductFilter
     */
    'productIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductFilter
     */
    'brandIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductFilter
     */
    'seriesIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductFilter
     */
    'fitIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductFilter
     */
    'categoryIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductFilter
     */
    'sizeIds'?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductFilter
     */
    'stock'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductFilter
     */
    'color'?: string;
    /**
     * 
     * @type {Array<Size>}
     * @memberof ProductFilter
     */
    'sizes'?: Array<Size>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductFilter
     */
    'seasons'?: Array<ProductFilterSeasonsEnum>;
    /**
     * 
     * @type {number}
     * @memberof ProductFilter
     */
    'minPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductFilter
     */
    'maxPrice'?: number;
}

export const ProductFilterSortOrderEnum = {
    Asc: 'Asc',
    Desc: 'Desc'
} as const;

export type ProductFilterSortOrderEnum = typeof ProductFilterSortOrderEnum[keyof typeof ProductFilterSortOrderEnum];
export const ProductFilterSeasonsEnum = {
    Winter: 'WINTER',
    Spring: 'SPRING',
    Summer: 'SUMMER',
    Autumn: 'AUTUMN'
} as const;

export type ProductFilterSeasonsEnum = typeof ProductFilterSeasonsEnum[keyof typeof ProductFilterSeasonsEnum];


